import { styledOmitCustomProps } from '@braskai/ui-kit';

import { css, styled } from '@mui/material';

import { SDialog as SUpsellDialog, STitle as SUpsellTitle } from '../../../ui/upsell/styled';

const MOBILE_BOTTOM_CLEARANCE = 'calc(88px + env(safe-area-inset-bottom, 0px))';

export const SDialog = styled(SUpsellDialog)(
  ({ theme }) => css`
    ${theme.breakpoints.down('tablet')} {
      .MuiDialog-paper {
        max-height: calc(100% - 16px - ${MOBILE_BOTTOM_CLEARANCE});
        margin-bottom: ${MOBILE_BOTTOM_CLEARANCE};
      }
    }
  `,
);

export const STitle = styled(SUpsellTitle)`
  padding-right: 32px;
`;

export const SCards = styled('div')(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
    margin-top: 32px;

    ${theme.breakpoints.down('tablet')} {
      grid-template-columns: 1fr;
      margin-top: 24px;
    }
  `,
);

export const SCard = styled(
  'div',
  styledOmitCustomProps,
)<{ $isPopular: boolean }>(
  ({ $isPopular, theme }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 20px;
    border: ${$isPopular ? `2px solid ${theme.palette.primary[600]}` : `1px solid ${theme.palette.grey[200]}`};
    border-radius: 16px;
    background-color: ${theme.palette.common.white};

    ${theme.breakpoints.down('tablet')} {
      gap: 12px;
      padding: 16px;
    }
  `,
);

export const SBadge = styled('div')(
  ({ theme }) => css`
    position: absolute;
    top: -13px;
    right: 23px;

    ${theme.breakpoints.down('tablet')} {
      right: 20px;
    }
  `,
);

export const SMinutes = styled('div')(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px;
    border-radius: 8px;
    background-color: ${theme.palette.grey[50]};
    color: ${theme.palette.common.black};

    svg {
      flex-shrink: 0;
    }
  `,
);
